module.exports = __webpack_public_path__ + "public/SiteIcons/bedsModalIcon.svg?f67f04c3";